import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  textField: {
    width: '100%',
    marginTop: '8px',
    '& .MuiInputBase-root': {
      height: '32px',
      margin: '0px',
      marginTop: '8px',
      '& .MuiInputBase-input': {
        border: 'none',
        '&:disabled': {
          backgroundColor: 'transparent'
        }
      }
    }
  },
  switchControlLabel: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    padding: '0px',
    margin: '0px'
  },
  controls: {
    className: 'no-format',
    style: { display: 'none' }
  },
  watermarkLength: {
    display: 'block',
    textAlign: 'right',
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    marginTop: '4px'
  }
});
